import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "../../services/fetchApi";

export const useGetTypesContracts = () => {
  const promise = () => fetchApi("/api/type_contracts", { method: "get" });
  return useQuery(["typescontracts"], promise, {});
};
